export enum ProvidersType {
  Google = 'google',
  AmazonS3 = 'amazon-s3',
  Microsoft = 'microsoft'
}
